<template>
	<div class="rounded-xl shadow bg-white my-3" style="height: 180px">
		<div class="flex justify-start h-full">
			<div class="w-4 h-full bg-gray-700 text-white rounded-l-xl">
				<div class="rotate-90 relative top-1/3">
					{{ __("Auktion") }}
				</div>
			</div>
			<div class="w-full relative">
				<div class="flex justify-start p-4 pl-3">
					<div class="max-h-[5rem] max-w-[5rem]">
						<ui-icon class="h-full" :name="productIconName" />
					</div>
					<div class="text-gray-700 text-xl font-semibold w-full">
						<div class="flex justify-between p-4 pb-0 pt-1">
							<!--span>{{ offer.product__origin }}</span-->
							<div>{{ productArticle }}</div>
							<div>{{ offer.product.harvest || __("n.a.") }}</div>
						</div>
						<div class="text-gray-500 text-xs font-medium pl-4 pb-3">
							<div v-if="productArticleGrade" class="h-4">
								{{ productArticleGrade }}
							</div>
							<div v-else class="h-4"></div>
						</div>
						<div v-if="hasBid">
							<div class="text-green text-2xl font-semibold pl-4">
								{{ __("Gebot abgegeben") }}
							</div>
						</div>
						<div v-else>
							<div class="text-gray-500 text-sm font-medium pl-4">
								{{
									$cropOptions.getLocalizedLabel(
										offer.location.mode,
										$cropOptions.locationModeOptions
									)
								}}
							</div>
							<div class="text-gray-500 text-sm font-medium pl-4">
								{{ offer.location.address.zip }}
								{{ offer.location.address.city }} ({{
									offer.distance_km.toFixed(0)
								}}
								km)
							</div>
							<div class="text-gray-500 text-sm font-medium pl-4">
								{{ $cropOptions.dateToString(offer, locale, true) }}
							</div>
						</div>
					</div>
				</div>
				<p class="text-2xl font-extrabold absolute bottom-0 left-8 my-4">
					{{ offer.auction.qty_mt || __("n.a.") }}&nbsp;t
				</p>
				<ui-button
					class="absolute bottom-0 right-5 my-4"
					:type="!auctionBiddingIsActive ? 'primary-disabled' : 'primary'"
					:disabled="!auctionBiddingIsActive"
					v-on:click="
						$bus.$emit(
							'toggle-iframe-modal',
							$route('auction.bid', {
								offerId: offer.id,
							}) + '&iframe_modal=true'
						)
					"
				>
					<span v-if="hasBid">
						{{ __("Ihren Preis anpassen") }}
					</span>
					<span v-else>
						{{ __("Zum Angebot") }}
					</span>
				</ui-button>
			</div>
		</div>
	</div>
</template>

<script>
// let options = require("../../cropOptions");

export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		auction: {
			type: Object,
			required: true,
		},
		auctionBiddingIsActive: {
			type: Boolean,
			required: true,
		},
	},
	data: function () {
		return {};
	},
	computed: {
		productArticle() {
			return this.__(
				this.getLabel(
					this.offer.product.grade,
					this.$cropOptions.productGradeOptions
				)
			).split(" (")[0];
		},
		productArticleGrade() {
			var articleName = this.getLabel(
				this.offer.product.grade,
				this.$cropOptions.productGradeOptions
			);
			if (articleName.includes("(")) {
				articleName = "(" + articleName.split("(")[1];
				return this.__(articleName);
			} else {
				return " ";
			}
		},
		auctionHammerUrl() {
			return window.baseUrl + "/images/auction-hammer.svg";
		},
		productIconName() {
			return this.offer.product.type.toLowerCase();
		},
		hasBid() {
			return this.offer.auctionBids.length > 0;
		},
	},
	methods: {
		getLabel(what, where) {
			return this.$cropOptions.getLabel(what, where);
		},
	},
};
</script>
